import qs from 'qs';
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';
import familySearchOverviewMf from '@/subview_plugins/FamilySearchOverview/manifest.js';
import { useFamilySearchUrlParams } from '@/composables/use-family-search-url-params';

// 同族库分组模式标识 (同族库分组模式会进入同族库的详情页)
export const FAMILY_SEARCH_INDEX_TAG = 'FSI';
// 同族库分组模式标识 (同族库分组模式会进入同族库的详情页)
export const FAMILY_SEARCH_TYPE_TAG = 'FSI';
// 同族库不分组模式标识 (同族库不分组模式需要进入普通详情页，但是需要隐藏header)
export const FAMILY_SEARCH_UNGROUP_TAG = 'search_mode';
export const FAMILY_OVERVIEW_PLUGIN_NAME = familySearchOverviewMf.name;

// 同族库分组模式为“同申请”
export const FAMILY_SEARCH_TYPE_APNO = 'apno';

export const getIsFamilySearch = () => {
    const searchParams = qs.parse(window.location.search, { ignoreQueryPrefix: true }) || {};
    return searchParams[FAMILY_SEARCH_INDEX_TAG] !== undefined;
};

export const getIsFamilySearchWithUngroup = () => {
    const searchParams = qs.parse(window.location.search, { ignoreQueryPrefix: true }) || {};
    return (searchParams[FAMILY_SEARCH_INDEX_TAG] === undefined) && (searchParams[FAMILY_SEARCH_UNGROUP_TAG] === 'family');
};

export const useFamilySearch = () => {
    const route = useRoute();
    const { workspaceId, folderId, familySearchType } = useFamilySearchUrlParams();

    const isFamilySearch = computed(() => {
        return route.query[FAMILY_SEARCH_INDEX_TAG] !== undefined;
    });

    const isFamilySearchWithUngroup = computed(() => {
        return (route.query[FAMILY_SEARCH_INDEX_TAG] === undefined) && (route.query[FAMILY_SEARCH_UNGROUP_TAG] === 'family');
    });

    const isInFamilyOverview = computed(() => {
        return route?.meta?.pluginName === FAMILY_OVERVIEW_PLUGIN_NAME;
    });

    const isFamilySearchFromWorkspace = computed(() => {
        return !!workspaceId.value && !!folderId.value;
    });

    // 同申请
    const isApnoSearchType = computed(() => {
        return familySearchType.value === FAMILY_SEARCH_TYPE_APNO;
    });

    return {
        isFamilySearch,
        isFamilySearchWithUngroup,
        isInFamilyOverview,
        isFamilySearchFromWorkspace,
        isApnoSearchType,
    };
};
